<script>
	import { DonutChart as DonutChartCore } from '@carbon/charts'
	import BaseChart from './BaseChart.svelte'
	export let options
	export let data
	export let chart = undefined
	export let ref = undefined
</script>

<BaseChart
	{...$$restProps}
	Chart={DonutChartCore}
	{options}
	{data}
	bind:ref
	bind:chart
	on:load
	on:update
	on:destroy />
